import React, { SVGProps } from 'react';

const ApplicationIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M2.33301 4.1665H13.6664C14.2186 4.1665 14.6664 4.61422 14.6664 5.1665C14.6664 5.71878 14.2186 6.1665 13.6664 6.1665H2.33301C1.78073 6.1665 1.33301 5.71878 1.33301 5.1665C1.33301 4.61422 1.78073 4.1665 2.33301 4.1665Z"
                fill="white"
            />
            <path
                d="M2.33301 0.833252H13.6664C14.2186 0.833252 14.6664 1.28097 14.6664 1.83325C14.6664 2.38553 14.2186 2.83325 13.6664 2.83325H2.33301C1.78073 2.83325 1.33301 2.38553 1.33301 1.83325C1.33301 1.28097 1.78073 0.833252 2.33301 0.833252Z"
                fill="white"
            />
            <path
                d="M12.3333 16.1667H3.66666C1.64253 16.1645 0.00221875 14.5241 0 12.5V9.83334C0 8.54466 1.04466 7.5 2.33334 7.5H4.66669C5.21897 7.5 5.66669 7.94772 5.66669 8.5C5.66669 9.42047 6.41288 10.1667 7.33334 10.1667H8.66669C9.58716 10.1667 10.3333 9.42047 10.3333 8.5C10.3333 7.94772 10.7811 7.5 11.3333 7.5H13.6667C14.9553 7.5 16 8.54466 16 9.83334V12.5C15.9978 14.5241 14.3575 16.1645 12.3333 16.1667ZM2.33334 9.5C2.14925 9.5 2 9.64925 2 9.83334V12.5C2 13.4205 2.74619 14.1667 3.66666 14.1667H12.3333C13.2538 14.1667 14 13.4205 14 12.5V9.83334C14 9.64925 13.8507 9.5 13.6667 9.5H12.1947C11.7456 11.0767 10.306 12.1648 8.66666 12.1667H7.33331C5.69397 12.1648 4.25434 11.0767 3.80531 9.5H2.33334Z"
                fill="white"
            />
        </svg>
    );
};

export default ApplicationIcon;
